import { useQuery } from '@tanstack/react-query';
import { projectDetailService } from '../services/projectDetail.service';

export function useProjectDetail(id: string) {
  const query = useQuery({
    queryKey: ['projects1', 'detail', id],
    queryFn: () => projectDetailService.getProject(id),
    enabled: !!id,
  });

  return {
    project: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
